import { generateApiClients } from '@app/utils/apiUtils'

const { apiClients, apiClientsNoTransform } = generateApiClients('dp')

export { apiClients, apiClientsNoTransform }
